export default "__VITE_ASSET__CkCd5WyJ__"